/**
 * Funções puras para lógica de negócio das frases
 */

/**
 * Verifica se todas as palavras prefixadas foram pronunciadas corretamente
 * @param {Array} wordStatuses - Array com status das palavras
 * @returns {boolean} True se todas as palavras estão corretas
 */
export const areAllPrefixedWordsCorrect = (wordStatuses) => wordStatuses.every(w => w.status === 'correct');


/**
 * Verifica se o turno foi completado
 * @param {boolean} allPrefixedWordsCorrect - Se todas as palavras prefixadas estão corretas
 * @param {string} spokenContinuation - Continuação falada da frase
 * @param {number} minContinuationWords - Número mínimo de palavras na continuação
 * @returns {Object} Objeto com status de completude e informações de debug
 */
export const checkTurnCompletion = (allPrefixedWordsCorrect, spokenContinuation, minContinuationWords = 4) => {
  const wordsCount = spokenContinuation
    ? spokenContinuation.trim().split(/\s+/).filter(Boolean).length
    : 0;

  const completed = allPrefixedWordsCorrect && wordsCount >= minContinuationWords;

  return {
    completed,
    wordsCount,
    minContinuationWords
  };
};

/**
 * Determina qual participante é o "first" (quem completa primeiro)
 * @param {string} lastCompleter - Último participante que completou ('A' ou 'B')
 * @param {Object} participantA - Participante A
 * @param {Object} participantB - Participante B
 * @returns {Object} Participante que deve completar primeiro
 */
export const determineFirstParticipant = (lastCompleter, participantA, participantB) => lastCompleter === "A" ? participantA : participantB;

/**
 * Gera a ação de completude baseada no participante atual
 * @param {string} whoAmI - Identificador do participante atual ('A' ou 'B')
 * @returns {string} Ação de completude ('A_COMPLETED' ou 'B_COMPLETED')
 */
export const generateCompletionAction = (whoAmI) => whoAmI === 'A' ? 'A_COMPLETED' : 'B_COMPLETED';

/**
 * Loga informações de completude do turno
 * @param {string} action - Ação sendo enviada
 * @param {string} whoAmI - Identificador do participante
 * @param {string} spokenContinuation - Continuação falada
 * @param {boolean} turnCompleted - Status de completude
 */
// eslint-disable-next-line no-unused-vars
export const logTurnCompletion = (actionData, whoAmI, spokenContinuation, turnCompleted) => {
  // Log removido para produção
};

/**
 * Função para lidar com clique em palavra (apenas log)
 * @param {string} word - Palavra clicada
 */
// eslint-disable-next-line no-unused-vars
export const handleWordClick = (word) => {
  // Log removido para produção
};
